import React, { useEffect, useState } from 'react';
import './CheckBoxFieldComponent.scss';
import { useUploadPicture } from '@/features/location/api/locationRequests';
import { FormField } from '../types';
import { log } from 'console';
import { Form } from 'react-bootstrap';
type CheckBoxFieldComponentProps = {
  data?: FormField;
  onChange?: (data: string[]) => void;
  disabled?: boolean;
};
export const CheckBoxFieldComponent = ({
  data,
  disabled,
  onChange,
}: CheckBoxFieldComponentProps) => {
  const uploadPicture = useUploadPicture();
  const [checkboxData, setCheckBoxData] = useState<string[]>([]);
  useEffect(() => {
    if (data) {
      setCheckBoxData(data.fieldValue ? data.fieldValue : []);
    }
  }, [data]);
  const onCheckBoxChange = (value: string) => {
    if (checkboxData.indexOf(value) >= 0) {
      checkboxData.splice(checkboxData.indexOf(value), 1);
    } else {
      checkboxData.push(value);
    }
    const newValue = [...checkboxData];
    setCheckBoxData(newValue);
    onChange && onChange(newValue);
  };
  return (
    <div className={`checkbox-field ${data?.options && data?.options.length > 3 ? 'wrap' : ''}`}>
      <div className="pet-row pl-2">
        <div className="p-checkbox-group p-pl-30">
          {data?.options &&
            data?.options.map((fo, index) => (
              <>
                <label className="container-1">
                  <Form.Check
                    inline
                    key={`checkbox-${data.fieldName.trim().toLowerCase() + index}`}
                    type="checkbox"
                    name={`checkbox-${data.fieldName.trim().toLowerCase()}`}
                    disabled={disabled}
                    onChange={() => onCheckBoxChange(fo.value)}
                    checked={checkboxData && checkboxData.indexOf(fo.value) >= 0 ? true : false}
                  />
                  <span>{fo.label}</span>
                </label>
                {data.options && data.options?.length - 1 !== index && (
                  <div className="pet-details-divider"></div>
                )}
              </>
            ))}
        </div>
      </div>
    </div>
  );
};
